import { api } from './index';
import axios from 'axios';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getUploadURL(ext, purpose) {
    const params = {
      file_extension: ext,
      file_purpose: purpose,
    };
    const url = '/uploads/sign_images';
    return api.get(url, { params: omitBy(params, isNil) });
  },
  uploadImage(file, url) {
    return axios({
      headers: {
        "Content-Type": file.type
      },
      method: 'PUT',
      url: url,
      data: file,
    });
  },
};
